import { X, Clock, XCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import Button from "../Common/Button";
import { toConstantCase } from "../../utils/string";

const AccountStatusModal = ({ isOpen, onClose, status, reason }) => {
    const { t } = useTranslation();
    if (!isOpen) return null;

    const statusLower = status?.toLowerCase();
    const isPending = statusLower === "pending";
    const isInactive = statusLower === "inactive";
    const statusLabel = status ? t(toConstantCase(status)) : "";
    const reasonLabel = reason ? t(toConstantCase(reason)) : "";

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4 py-4">
            <div className="relative w-full max-w-md rounded-2xl bg-white shadow-[0_20px_60px_rgba(0,0,0,0.2)]">
                <button
                    type="button"
                    onClick={onClose}
                    className="absolute right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 focus:outline-none hover:bg-slate-200 transition"
                >
                    <X className="h-5 w-5 text-slate-500" />
                </button>

                <div className="p-8">
                    <div className={`mx-auto flex h-14 w-14 items-center justify-center rounded-full ${isPending ? "bg-amber-100" : "bg-red-100"}`}>
                        {isPending
                            ? <Clock className="h-7 w-7 text-amber-500" />
                            : <XCircle className="h-7 w-7 text-red-500" />
                        }
                    </div>

                    <h2 className="mt-5 text-center text-lg font-semibold text-slate-900">
                        {t("AUTH_ACCOUNT_STATUS_TITLE")} <span className={isPending ? "text-amber-500" : "text-red-500"}>{statusLabel}</span>
                    </h2>

                    <p className="mt-3 text-center text-sm text-slate-500">
                        {isPending
                            ? t("AUTH_ACCOUNT_STATUS_PENDING_MESSAGE")
                            : isInactive
                                ? t("AUTH_ACCOUNT_STATUS_INACTIVE_MESSAGE")
                                : t("AUTH_ACCOUNT_STATUS_REJECTED_MESSAGE")
                        }
                    </p>

                    {reason && (
                        <div className={`mt-4 rounded-lg px-4 py-3 text-sm ${isPending ? "bg-amber-50 text-amber-700" : "bg-red-50 text-red-700"}`}>
                            <span className="font-semibold">{t("AUTH_COMMON_REASON")} </span>{reasonLabel}
                        </div>
                    )}

                    <Button
                        type="button"
                        onClick={onClose}
                        className="mt-6 w-full"
                    >
                        {t("COMMON_CLOSE")}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default AccountStatusModal;
